import { useState } from "react";
import "./Navbar.css";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu  = () => setMenuOpen(false);

  return (
    <nav className="navbar">


      <a href="#hero" className="nav-logo">
        L<span>.</span> da Vinci
      </a>

      <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
        <li><a href="sec2"  onClick={closeMenu}>Overview</a></li>
        <li><a href="collage"   onClick={closeMenu}>Collage</a></li>
        <li><a href="sec3"  onClick={closeMenu}>Timeline</a></li>
        <li><a href="sec4"     onClick={closeMenu}>Quotes</a></li>
        <li><a href="footer"     onClick={closeMenu}>Legacy</a></li>
      </ul>

      <button
        className={`hamburger ${menuOpen ? "active" : ""}`}
        onClick={toggleMenu}
        aria-label="Toggle menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

    </nav>
  );
}

export default Navbar;